import React from 'react'
import { DepositHeader } from '../index'
import TipsView from '../Components/TipsView'
import CopyView from '../Components/CopyView'
import QRCodeUrlView from '../Components/QRCodeUrlView'
import html2canvas from 'html2canvas';
import SubmitBtn from '../Components/SubmitBtn'
import Modal from "../Components/Modal";
import NextStepCon from '$Deposits/Components/BQR/NextStep'
const download = require('downloadjs');
import { GetParamsData } from '$Deposits/lib/LibCommonData'


class NextStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
        this._viewShotRef = null
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    //下載分享圖片
    downloadShareImage = async () => {
        html2canvas(document.querySelector('#qrcode'), { useCORS: true })
            .then((canvas) => {
                download(canvas.toDataURL('image/png'), `QRcode${Math.floor(Math.random() * 1000 + 1)}.png`);
                setTimeout(() => {
                    const { toastTip } = GetParamsData()
                    toastTip.success('บันทึกสำเร็จ')
                }, 1500);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    render() {


        return (
            <>
                <NextStepCon
                    Modal={(propCon) => {
                        const { modalVisible, title, msg, onOk } = propCon
                        return (
                            <Modal
                                className='modalTips designateAmountModal'
                                visible={modalVisible}
                                title={title}
                                onlyOkBtn={true}
                                okText='ตกลง'
                                onOk={onOk}
                            >
                                <>
                                    <p className="intro">{msg}</p>
                                </>
                            </Modal>
                        )
                    }}
                    ModalWarning={(propCon) => {
                        const { modalVisible, modes, title, cancelText, okText, onCancel, onOk, msg } = propCon
                        return (
                            <Modal
                                className='modalTips'
                                visible={modalVisible}
                                title={title}
                                onlyOkBtn={true}
                                cancelText={cancelText}
                                okText={okText}
                                onCancel={onCancel}
                                onOk={onOk}
                            >
                                <>
                                    <div className='titleIcon'>
                                        <div className={`${modes}Icon imgIcon`} />
                                    </div>
                                    <p className="intro">{msg}</p>
                                </>
                            </Modal>
                        )
                    }}

                    NextStep={(propCon) => {
                        const {
                            MethodsActive,
                            DepositPayments,
                            backClick,
                            onChange
                        } = propCon

                        const { uniqueAmount, returnedBankDetails, qrDeepLink, isDummyBank } = DepositPayments || {}
                        const { accountHolderName, bankName } = returnedBankDetails || {}
                        return (
                            <div className='nextModal BQR'>
                                <div className='nextModalCenter'>
                                    <div className='viewArea'>
                                        <TipsView msg={'กรุณาเปิดแบงก์กิ้งแอปเพื่อสแกน QR และโอนเงินตามจำนวนที่ ระบบกำหนดภายใน 5 นาทีเท่านั้น โปรดตรวจสอบให้แน่ใจว่าคุณใช้ ธนาคารชื่อเดียวกับที่ลงทะเบียนในการฝากมิฉะนั้นการปรับเงินอาจล่าช้า'} />
                                        <div className='content'>

                                            <CopyView
                                                copyTitle={'ยอดฝาก'}
                                                copyValue={uniqueAmount}
                                                copyType={'uniqueAmount'}
                                            />

                                            <div className='amount'>
                                                <span className='amountTitle'>ธนาคาร</span>
                                                <span className='amountValue'>{bankName}</span>
                                            </div>

                                            <div className='tripsErr'>คำเตือน : QR Code สามารถใช้ได้เพียง 1 ครั้งเท่านั้น ไม่สามารถใช้ซ้ำได้ </div>


                                            {/* qrcode */}
                                            <div className='QD-qrCode' onClick={this.viewShots}>
                                                <span className='QRTitle'>คิวอาร์โค้ด</span>
                                                <div className='QRCode'>
                                                    <QRCodeUrlView deepLink={qrDeepLink} />
                                                    <div className='DQ-download' onClick={this.downloadShareImage}>
                                                        <div className='downloadIcon'/>
                                                        <p>บันทึก QR</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <SubmitBtn
                                        onPress={onChange}
                                        submitBtnItem={'โอนเงินมาเรียบร้อยแล้ว'}
                                    />
                                </div>
                            </div>
                        )
                    }}

                />





            </>
        );
    }
}

export default NextStep


